module.exports = __webpack_public_path__ + "img/loadingAnimation.964e9d6f.svg";